import allThemas from './themas.json';

export type Thema = {
  CodeValue: string;
  CodeDescription: string;
  CodeNotes: string;
  CodeParent: string;
  IssueNumber: number;
  Modified: number;
};
export const themas: Thema[] = allThemas.CodeList.ThemaCodes.Code;
